export default {
  sm: '4px',
  md: '8px',
};
